import { compositeKeyString } from "../util/panel";
import { getImages } from "../selectors";
import { cleanPanelResponse } from "../network/image";
import { DELETE_PANEL_FRAME_ACTIVE_IMAGE } from "./panel";
import _ from "lodash";

export const UPDATE_IMAGES_SUCCESS = "UPDATE_IMAGES_SUCCESS";

export function updateImagesSuccess(json) {
  let newData = cleanPanelResponse(json.data);

  return (dispatch, getState, networkManager) => {
    // Check for an updated image for a frame
    var frameListLists = getImages(getState()).items;

    for (let frameListList of frameListLists) {
      let newFrameListList = newData.find(
        nfll => compositeKeyString(nfll) === compositeKeyString(frameListList)
      );
      if (newFrameListList) {
        for (let frameList of frameListList.frameLists) {
          let newFrameList = newFrameListList.frameLists.find(
            nfl => nfl.id === frameList.id
          );
          if (newFrameList) {
            for (let frame of frameList.frames) {
              let newFrame = newFrameList.frames.find(nf => nf.id === frame.id);
              if (newFrame) {
                if (
                  !_.isEqual(
                    new Set(frame.images.map(i => i.id)),
                    new Set(newFrame.images.map(i => i.id))
                  )
                ) {
                  dispatch({
                    type: DELETE_PANEL_FRAME_ACTIVE_IMAGE,
                    frameId: frame.id
                  });
                }
              }
            }
          }
        }
      }
    }

    // Update the image data in the store
    dispatch({
      type: UPDATE_IMAGES_SUCCESS,
      images: newData,
      receivedAt: Date.now()
    });
  };
}
